import { render, staticRenderFns } from "./BgColumnTags.vue?vue&type=template&id=507eca0a"
import script from "./BgColumnTags.vue?vue&type=script&lang=js"
export * from "./BgColumnTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports